<template>
  <div class="my-licence">
    <div class="account-card">
      <div class="account-card-header">
        <h4 class="account-card-title">我的订单</h4>
      </div>
      <query-tabs
        :query-tabs="queryTabs"
        :active.sync="activeName"
      ></query-tabs>
      <div class="page-manage page-manage-evaluation-config">
        <customize-form
          :form-config="formConfig"
          @on-query="onQuery"
          @on-reset="onReset"
          ref="customize"
        ></customize-form>
        <customize-table
          :table-config="tableConfig"
          @size-change="onSizeChange"
          @current-change="onCurrentChange"
          :currentPage.sync="params.pageIndex"
        >
          <template v-slot:noticeTitle="{ column }">
            <el-table-column v-bind="column">
              <template v-slot="scope">
                <span class="cell-link" @click="onCheckBidFile(scope.row)">{{
                  scope.row.noticeTitle
                }}</span>
              </template>
            </el-table-column>
          </template>
          <template v-slot:buyerCompName="{ column }">
            <el-table-column v-bind="column">
              <template v-slot="scope">
                <span class="cell-link" @click="onShowBuyer(scope.row)">{{
                  scope.row.buyerCompName
                }}</span>
              </template>
            </el-table-column>
          </template>
          <template v-slot:dealPrice="{ column }">
            <el-table-column v-bind="column">
              <template v-slot="scope">
                <span v-if="scope.row.bidCode == '05'"
                  >{{ scope.row.dealPrice | numberFormat(2) }}(元/{{
                    scope.row.unitName
                  }})</span
                >
                <span v-if="scope.row.bidCode == '10'"
                  >{{ scope.row.dealPrice | numberFormat(2) }}元</span
                >
              </template>
            </el-table-column>
          </template>
          <template v-slot:assetClass="{ column }">
            <el-table-column v-bind="column">
              <template v-slot="scope">
                <span>{{
                  scope.row.assetClass == 1
                    ? '废旧物资'
                    : scope.row.assetClass == 2
                    ? '闲置物资'
                    : ''
                }}</span>
              </template>
            </el-table-column>
          </template>
          <template v-slot:dealTotalPrice="{ column }">
            <el-table-column v-bind="column">
              <template v-slot="scope">
                <span v-if="scope.row.dealTotalPrice">{{
                  scope.row.dealTotalPrice | numberFormat(2)
                }}</span>
              </template>
            </el-table-column>
          </template>
          <template v-slot:shipmentsTotalPrice="{ column }">
            <el-table-column v-bind="column">
              <template v-slot="scope">
                <span v-if="scope.row.shipmentsTotalPrice">
                  <span>{{
                    scope.row.shipmentsTotalPrice | numberFormat(2)
                  }}</span>
                </span>
              </template>
            </el-table-column>
          </template>
          <template v-slot:statusCode="{ column }">
            <el-table-column v-bind="column">
              <template v-slot="scope">
                <span>{{ statusCodeFun(scope.row.statusCode) }}</span>
              </template>
            </el-table-column>
          </template>
          <template v-slot:payMethod="{ column }">
            <el-table-column v-bind="column">
              <template v-slot="scope">
                <span>{{
                  scope.row.payMethod === 1 ? '线下支付' : '线上支付'
                }}</span>
              </template>
            </el-table-column>
          </template>
          <template v-slot:dismantleWhether="{ column }">
            <el-table-column v-bind="column">
              <template v-slot="scope">
                <span>{{ scope.row.dismantleWhether == 1 ? '是' : '否' }}</span>
              </template>
            </el-table-column>
          </template>
          <template v-slot:operations="{ column }">
            <el-table-column v-bind="column" fixed="right">
              <template v-slot="scope">
                <div
                  v-if="
                    scope.row.serveScope == 2 && scope.row.dismantleWhether != 1
                  "
                >
                  <div
                    @click="Deliverycheck(scope.row)"
                    class="cellbutton text"
                    v-if="
                      (scope.row.shipmentsConfirmResult == '-1' ||
                        scope.row.shipmentsConfirmResult == '2') &&
                        activeName == 1
                    "
                  >
                    登记发货
                  </div>
                  <div
                    v-else
                    @click="Deliverycheck(scope.row)"
                    class="cellbutton text"
                  >
                    查看
                  </div>
                  <!-- <div
                  @click="onCompleted(scope.row)"
                  class="cellbutton text"
                  v-if="activeName == 1 && scope.row.clearanceRecordCount > 0"
                >
                  查看未完成发货说明
                </div> -->
                  <!-- <div
                  @click="onConsignment(scope.row)"
                  class="cellbutton text"
                  v-if="scope.row.transportRecordStatus == 4"
                >
                  审核拉货登记
                </div> -->
                  <div
                    @click="onConsignment(scope.row)"
                    class="cellbutton text"
                    v-if="scope.row.transportRecordStatus == 3"
                  >
                    查看拉货登记
                  </div>
                </div>
              </template>
            </el-table-column>
          </template>
        </customize-table>
      </div>
    </div>
    <el-dialog
      title="成交商信息"
      :visible.sync="dialogBuyer"
      :modal-append-to-body="false"
    >
      <el-form>
        <el-row :gutter="20">
          <el-col :span="11">
            <el-form-item label="成交商:"
              >{{
                dialogBuyerData && dialogBuyerData.compName
                  ? dialogBuyerData.compName
                  : ''
              }}
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="联系人:"
              >{{
                dialogBuyerData && dialogBuyerData.contName
                  ? dialogBuyerData.contName
                  : ''
              }}
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="11">
            <el-form-item label="电话:"
              >{{
                dialogBuyerData && dialogBuyerData.contPhone
                  ? dialogBuyerData.contPhone
                  : ''
              }}
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="手机:"
              >{{
                dialogBuyerData && dialogBuyerData.contMobile
                  ? dialogBuyerData.contMobile
                  : ''
              }}
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="11">
            <el-form-item label="邮箱:"
              >{{
                dialogBuyerData && dialogBuyerData.contEmail
                  ? dialogBuyerData.contEmail
                  : ''
              }}
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="传真:"
              >{{
                dialogBuyerData && dialogBuyerData.contFax
                  ? dialogBuyerData.contFax
                  : ''
              }}
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogBuyer = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { dateranged, openNewPage } from '@/utils/constantime'

export default {
  components: {},
  data() {
    return {
      selectRow: {},
      showVisible: false,
      dialogBuyer: false,
      dialogBuyerData: {},
      removeV: 1,
      pageNum: 1,
      pageSize: 10,
      params: {
        pageIndex: 1,
        pageSize: 10
      },
      activeName: 1,
      queryTabs: [
        {
          label: 1,
          name: '未完成'
        },
        {
          label: 2,
          name: '执行完成'
        }
      ],
      formConfig: {
        configs: {
          noticeCode: {
            tag: 'input',
            label: '公告编号'
          },
          noticeTitle: {
            tag: 'input',
            label: '公告标题'
          },
          disposerCompName: {
            tag: 'input',
            label: '委托企业'
          },
          planCode: {
            tag: 'input',
            label: '委托编号'
          },
          assetClass: {
            tag: 'select',
            label: '物资类型',
            options: [
              { value: 1, label: '废旧物资' },
              { value: 2, label: '闲置物资' }
            ]
          },

          statusCode: {
            tag: 'select',
            label: '状态',
            default: null,
            //statusCode 0、1、1-1、1-3 可以修改 其他不能修改
            options: [
              { value: null, label: '全部' },
              { value: '0', label: '待执行' },
              { value: '1', label: '执行中' },
              { value: '1-1', label: '待付款' },
              { value: '1-2', label: '结算待确认' },
              { value: '1-3', label: '结算确认不通过' },
              { value: '1-4', label: '结算已确认' },
              { value: '2', label: '执行完成' }
            ]
          },
          dismantleWhether: {
            tag: 'select',
            label: '是否拆卖一体',
            default: null,
            //statusCode 0、1、1-1、1-3 可以修改 其他不能修改
            options: [
              { value: 1, label: '是' },
              { value: 0, label: '否' }
            ]
          },
          buyerCompName: {
            tag: 'input',
            label: '买受人'
          },
          dealDate: {
            ...dateranged,
            label: '成交日期'
          }
        },
        operations: [
          {
            label: '查询',
            handler: 'on-query',
            type: 'primary'
          },
          {
            label: '清空',
            handler: 'on-reset',
            type: 'default'
          }
        ]
      },
      // 默认表格配置
      tableConfig: {
        isPagination: true,
        columns: [
          {
            label: '序号',
            type: 'index',
            width: '50px',
            align: 'center'
          },
          {
            prop: 'noticeCode',
            'show-overflow-tooltip': true,
            label: '公告编号',
            align: 'center',
            width: '160px'
          },
          {
            slot: 'noticeTitle',
            prop: 'noticeTitle',
            label: '公告标题',
            'show-overflow-tooltip': true,
            width: '150px'
          },
          {
            slot: 'assetClass',
            prop: 'assetClass',
            'show-overflow-tooltip': true,
            label: '物资类型',
            align: 'center'
          },
          {
            slot: 'dismantleWhether',
            prop: 'dismantleWhether',
            'show-overflow-tooltip': true,
            label: '是否拆卖一体',
            align: 'center'
          },
          {
            prop: 'planCode',
            'show-overflow-tooltip': true,
            label: '委托编号',
            align: 'center',
            width: '130px'
          },
          {
            prop: 'dealTime',
            label: '成交日期',
            align: 'center',
            width: '140px'
          },
          {
            slot: 'dealPrice',
            prop: 'dealPrice',
            label: '成交价',
            align: 'right',
            width: '160px'
          },
          {
            prop: 'dealTotalPrice',
            slot: 'dealTotalPrice',
            label: '成交金额(元)',
            align: 'right',
            width: '160px'
          },
          {
            slot: 'buyerCompName',
            prop: 'buyerCompName',
            label: '买受人',
            'show-overflow-tooltip': true,
            align: 'center',
            width: '160px'
          },
          {
            slot: 'payMethod',
            prop: 'payMethod',
            label: '货款收款方式',
            align: 'center',
            width: '110px'
          },
          {
            prop: 'payedPrice',
            label: '收款冻结金额(元）',
            align: 'center',
            width: '160px'
          },
          {
            slot: 'shipmentsTotalPrice',
            prop: 'shipmentsTotalPrice',
            label: '发货金额(元)',
            align: 'right',
            width: '110px'
          },
          {
            prop: 'disposerCompName',
            label: '委托企业',
            align: 'center',
            'show-overflow-tooltip': true,
            width: '160px'
          },
          {
            prop: 'statusCode',
            slot: 'statusCode',
            label: '状态',
            align: 'center',
            width: '100px'
          },
          {
            slot: 'operations',
            prop: 'operations',
            label: '操作',
            width: '160px',
            align: 'center',
            fixed: 'right'
          }
        ],
        data: [],
        total: 0
      }
    }
  },
  created() {
    //this.planListTodo()
  },
  watch: {
    activeName: {
      handler() {
        if (this.$refs.customize) {
          this.$refs.customize.$refs.queryForm.resetFields()
        }

        this.params = {
          pageIndex: this.pageNum,
          pageSize: this.pageSize
        }
        this.planListTodo()
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    statusCodeFun(code) {
      const obj = {
        '0': '待执行',
        '1': '执行中',
        '1-1': '待付款',
        '1-2': '结算待确认',
        '1-3': '结算确认不通过',
        '1-4': '结算已确认',
        '2': '执行完成'
      }
      return obj[code]
    },
    onCurrentChange(val) {
      this.params = {
        ...this.params,
        pageIndex: val,
        pageSize: 10
      }
      this.planListTodo()
    },
    onSizeChange(val) {
      this.params = {
        ...this.params,
        pageIndex: 1,
        pageSize: val
      }
      this.planListTodo()
    },
    onCheckBidFile(o) {
      let query = {
        id: o.noticeId
      }
      openNewPage('ServiceCompileMaterialCheck', query)
    },
    async onShowBuyer(o) {
      let data = await this.$api.enrooll.getEnroollByComp({
        noticeId: o.noticeId,
        buyerCompCode: o.buyerCompCode
      })

      this.dialogBuyer = true
      this.dialogBuyerData = data
    },
    async planListTodo() {
      let obj = {
        ...this.params,
        statusTag: this.activeName
      }
      let data = await this.$api.serviceProvider.getOrderlist(obj)
      this.tableConfig.data = data.data
      this.tableConfig.total = data.total
    },
    onCompleted(o) {
      let query = {
        id: o.id
      }
      this.$router.push({ name: 'Completed', query })
    },
    onQuery(val) {
      this.params = {
        ...val,
        pageIndex: this.pageNum,
        pageSize: this.pageSize,
        dealDateStart:
          val.dealDate && val.dealDate.length > 0 ? val.dealDate[0] : '',
        dealDateEnd:
          val.dealDate && val.dealDate.length > 0 ? val.dealDate[1] : '',
        dealDate: null
      }
      this.planListTodo()
    },
    remove(val) {
      this.removeV = val
    },
    onReset(val) {
      console.log(val)
      this.params = {
        pageIndex: this.pageNum,
        pageSize: this.pageSize
      }

      this.planListTodo()
    },
    //发货
    modify(o) {
      let query = {
        id: o.id
      }
      this.$router.push({ name: 'ServiceDelivery', query })
    },
    //查看
    Deliverycheck(o) {
      let query = {
        id: o.id,
        clearanceRecordCount: o.clearanceRecordCount
      }
      this.$router.push({ name: 'ServiceDeliverycheck', query })
    },
    onConsignment(row) {
      this.$router.push({
        name: 'OrderRegistration',
        query: {
          id: row.id,
          transportRecordStatus: row.transportRecordStatus //查看
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.text {
  margin-right: 8px;
}
.account-card-header {
  margin-bottom: 10px;
}
</style>
